import React from "react";
import { ActionButton } from "../../../../../../Common/Buttons/ActionButton";
import { Text as TextInput } from "../../../../../../Inputs";
import {
  ActionButtonContainer,
  InputContainer,
  LabelContainer,
  LVLabel,
  OptionsContainer,
} from "./__styles__/WidgetSettings";

const OptionsInput = ({
  dropdownOptions,
  setDropdownOption,
  removeDropdownOption,
  disabled = false,
}: {
  dropdownOptions: Array<string>;
  setDropdownOption: (index: number, value: string) => void;
  removeDropdownOption: (index: number) => void;
  disabled?: boolean;
}) => {
  return (
    <div>
      <LabelContainer>
        <LVLabel text={"Pill name"} />
      </LabelContainer>
      {dropdownOptions.map((option, index) => (
        <OptionsContainer key={`option.${index}`}>
          <InputContainer labelOnly>
            <TextInput
              onChange={value => setDropdownOption(index, value)}
              name={`label.${index}`}
              value={option}
              disabled={disabled}
            />
          </InputContainer>
          <ActionButtonContainer
            hidden={dropdownOptions.length === 1 || disabled}
          >
            <ActionButton
              icon="x"
              onClick={() => removeDropdownOption(index)}
            />
          </ActionButtonContainer>
        </OptionsContainer>
      ))}
    </div>
  );
};

export default OptionsInput;
